<template>
  <div>
    <label class="typo__label">{{ this.$t('fields.provider') }}</label>
    <Multiselect class="provider-combobox" v-model="value" :options="options" label="name" track-by="name"
      :placeholder="$t('placeholder.select')" :select-label="$t('hints.select')" :deselect-label="$t('hints.deselect')"
      :selected-label="$t('hints.selected')" @input="onInput" />
  </div>
</template>

<script>
import ProviderName from '@/components/ProviderName';
import Multiselect from 'vue-multiselect';

export default {
  name: 'provider-combobox',
  components: { ProviderName, Multiselect },
  data() {
    return {
      options: [
        { value: 'BRODOS', name: this.$t('providers.BRODOS') },
        { value: 'TELEKOM', name: this.$t('providers.TELEKOM') },
        { value: 'TVPP', name: this.$t('providers.TVPP') },
      ],
      value: '',
    };
  },
  methods: {
    onInput(selection) {
      this.$emit('input', selection.value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProviderComboBox.vue?cd5a3606